import Vue from 'vue'
import Router from 'vue-router'
import MainView from '@/components/main.vue'
import HelloWorld from '@/components/examples/HelloWorld.vue'
import Flexible from '@/components/examples/flexible-design/flexible-design.vue'
import ResponsiveLayoutVue from '@/components/global/responsive-layout.vue'
import EisartVue from "@/components/eisart/eisart-main.vue"
import ZweispalterFloatView from "@/components/css-examples/zweispalter-float.vue"
import ZweispalterTableView from "@/components/css-examples/zweispalter-table.vue"
import DreispalterFlexView from "@/components/css-examples/dreispalter-flex.vue"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/eisart'
    },
    {
      path: '/main',
      name: 'MainView',
      component: MainView
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/examples/flexible',
      name: 'Flexible',
      component: Flexible
    },
    {
      path: '/global/responsive',
      name: 'Responsive',
      component: ResponsiveLayoutVue
    },
    {
      path: '/eisart',
      name: 'Eisart',
      component: EisartVue
    },
    {
      path: '/zweispalter-float',
      name: 'ZweispalterFloat',
      component: ZweispalterFloatView
    },
    {
      path: '/zweispalter-table',
      name: 'ZweispalterTable',
      component: ZweispalterTableView
    },
    {
      path: '/dreispalter-flex',
      name: 'DreispalterFlex',
      component: DreispalterFlexView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js